import "core-js/modules/es.array.push.js";
import "core-js/modules/es.symbol.description.js";
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7642cf82"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "width": "100%",
    "text-align": "center"
  }
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "news-item-pic"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "news-item-cont"
};
const _hoisted_7 = {
  class: "news-item-title"
};
const _hoisted_8 = {
  class: "news-item-desc"
};
const _hoisted_9 = {
  class: "news-item-source"
};
const _hoisted_10 = {
  key: 0,
  class: "page-button"
};
const _hoisted_11 = {
  key: 1,
  class: "end"
};
import bannerBar from '@/components/banner';
import { ref, reactive, watch, onMounted, onUnmounted } from 'vue';
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router';
import { isMobile } from '@/utils';
import { getNewsList } from '@/api';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const basePath = window.appConfig.VUE_APP_PATH;
    const isloading = ref(false);
    const tablist = [{
      key: 'all',
      value: '全部'
    }, {
      key: 'crop',
      value: '公司动态'
    }, {
      key: 'policy',
      value: '政策解读'
    }, {
      key: 'know',
      value: '知识科普'
    }];
    const tabs = ref(['crop', 'policy', 'know'].includes(route.query.tab) ? route.query.tab : 'all');
    // let data = ref([
    //     {
    //         id: 1,
    //         title: '亲笔签助理企业：飞书People，把人才的价值最大化，用人的...',
    //         desc: '近日，在CIO时代、新基建创新研究院联合组织开展的“大信创产品目录”征集中，亲笔签电子合...',
    //         source: '2022/12/30',
    //         figure: ''
    //     },
    //     {
    //         id: 2,
    //         title: '亲笔签助理企业：飞书People，把人才的价值最大化，用人的...',
    //         desc: '近日，在CIO时代、新基建创新研究院联合组织开展的“大信创产品目录”征集中，亲笔签电子合...',
    //         source: '2022/12/30',
    //         figure: ''
    //     },
    //     {
    //         id: 3,
    //         title: '亲笔签助理企业：飞书People，把人才的价值最大化，用人的...',
    //         desc: '近日，在CIO时代、新基建创新研究院联合组织开展的“大信创产品目录”征集中，亲笔签电子合...',
    //         source: '2022/12/30',
    //         figure: ''
    //     },
    //     {
    //         id: 4,
    //         title: '亲笔签助理企业：飞书People，把人才的价值最大化，用人的...',
    //         desc: '近日，在CIO时代、新基建创新研究院联合组织开展的“大信创产品目录”征集中，亲笔签电子合...',
    //         source: '2022/12/30',
    //         figure: ''
    //     },
    //     {
    //         id: 5,
    //         title: '亲笔签助理企业：飞书People，把人才的价值最大化，用人的...',
    //         desc: '近日，在CIO时代、新基建创新研究院联合组织开展的“大信创产品目录”征集中，亲笔签电子合...',
    //         source: '2022/12/30',
    //         figure: ''
    //     },
    //     {
    //         id: 6,
    //         title: '亲笔签助理企业：飞书People，把人才的价值最大化，用人的...',
    //         desc: '近日，在CIO时代、新基建创新研究院联合组织开展的“大信创产品目录”征集中，亲笔签电子合...',
    //         source: '2022/12/30',
    //         figure: ''
    //     },
    //     {
    //         id: 7,
    //         title: '亲笔签助理企业：飞书People，把人才的价值最大化，用人的...',
    //         desc: '近日，在CIO时代、新基建创新研究院联合组织开展的“大信创产品目录”征集中，亲笔签电子合...',
    //         source: '2022/12/30',
    //         figure: ''
    //     },
    //     {
    //         id: 8,
    //         title: '亲笔签助理企业：飞书People，把人才的价值最大化，用人的...',
    //         desc: '近日，在CIO时代、新基建创新研究院联合组织开展的“大信创产品目录”征集中，亲笔签电子合...',
    //         source: '2022/12/30',
    //         figure: ''
    //     },
    //     {
    //         id: 9,
    //         title: '亲笔签助理企业：飞书People，把人才的价值最大化，用人的...',
    //         desc: '近日，在CIO时代、新基建创新研究院联合组织开展的“大信创产品目录”征集中，亲笔签电子合...',
    //         source: '2022/12/30',
    //         figure: ''
    //     }
    // ])
    const data = ref([]);
    const isLast = ref(false);

    // 初始化分页参数
    const pageOption = reactive({
      size: isMobile() ? 3 : 9,
      current: 1,
      total: 0,
      type: ['crop', 'policy', 'know'].indexOf(route.query.tab) + 1
    });

    // 分页元素——移动端滚动到目标位置触发分页
    const pageDom = ref(null);
    const imgUrl = id => {
      return `${window.appConfig.apiUrl}/openApi/file/imagePreview/${id}`;
    };
    onBeforeRouteUpdate(to => {
      tabs.value = ['crop', 'policy', 'know'].includes(to.query.tab) ? to.query.tab : 'all';
    });

    // tab变更切换数据列表
    watch(tabs, val => {
      router.replace({
        query: {
          tab: val
        }
      });
      data.value = [];
      pageOption.type = ['crop', 'policy', 'know'].indexOf(val) + 1;
      isLast.value = false;
      getDataList();
    });

    // 跳转到新闻详情
    const showDetail = id => {
      router.push(`${basePath}news/detail?id=${id}`);
    };

    // 显示source + time
    const sourceAndTime = item => {
      const arr = [];
      if (item.source !== '') {
        arr.push(item.source);
      }
      if (item.createTime !== '') {
        arr.push(item.createTime);
      }
      return arr.join(' | ');
    };

    // 获取新闻列表数据
    const getDataList = async () => {
      try {
        const $params = {
          ...pageOption
        };
        if (![1, 2, 3].includes($params.type)) {
          delete $params.type;
        }
        isloading.value = true;
        const res = await getNewsList($params);
        isloading.value = false;
        pageOption.size = res.size;
        pageOption.current = res.current;
        pageOption.total = res.total;
        if (isMobile()) {
          data.value = [...data.value, ...res.records];
        } else {
          data.value = [...res.records];
        }
        if (res.records.length < pageOption.size) {
          isLast.value = true;
        }
      } catch (e) {}
    };
    const nextPage = () => {
      if (!isLast.value) {
        pageOption.current += 1;
        getDataList();
      }
    };
    onMounted(() => {
      getDataList();

      // 移动端绑定滚动分页
      // if (isMobile()) {
      //     window.onscroll = () => {
      //         let pagePosition = pageDom.value.getBoundingClientRect().y //分页dom距离顶部位置
      //         let docHeight = document.documentElement.clientHeight //视窗高度
      // if (isMobile()) {
      //     window.onscroll = () => {
      //         let pagePosition = pageDom.value.getBoundingClientRect().y //分页dom距离顶部位置
      //         let docHeight = document.documentElement.clientHeight //视窗高度

      //         //滚动到分页了，开始加载数据
      //         if (pagePosition < docHeight && !isloading.value && pageOption.size * pageOption.current < pageOption.total) {
      //             pageOption.current += 1
      //             getDataList()
      //         }
      //     }
      // }
      //         //滚动到分页了，开始加载数据
      //         if (pagePosition < docHeight && !isloading.value && pageOption.size * pageOption.current < pageOption.total) {
      //             pageOption.current += 1
      //             getDataList()
      //         }
      //     }
      // }
    });

    onUnmounted(() => {
      if (isMobile()) window.onscroll = null;
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _component_a_config_provider = _resolveComponent("a-config-provider");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(bannerBar), {
        head: "亲笔签新闻中心",
        desc: "17年深耕 数字笔迹手写电子签名开创者",
        adCode: 1010,
        class: "banner-center"
      }), _createVNode(_component_a_config_provider, {
        locale: _unref(zhCN)
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, {
          class: _normalizeClass(_unref(isMobile)() ? 'qbq-tabs_m' : 'qbq-tabs'),
          activeKey: tabs.value,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => tabs.value = $event),
          size: "24px",
          centered: ""
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tablist, label => {
            return _createVNode(_component_a_tab_pane, {
              key: label.key,
              tab: label.value,
              class: "main"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [!data.value.length ? (_openBlock(), _createElementBlock("p", _hoisted_2, " 无数据 ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: "news-item",
                  key: index,
                  onClick: $event => showDetail(item.id)
                }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
                  src: imgUrl(item.backgroundImageId)
                }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.description), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(sourceAndTime(item)), 1)])], 8, _hoisted_3);
              }), 128))])]),
              _: 2
            }, 1032, ["tab"]);
          }), 64))]),
          _: 1
        }, 8, ["class", "activeKey"]), _unref(isMobile)() ? (_openBlock(), _createElementBlock("div", _hoisted_10, [!isLast.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "button",
          ref_key: "pageDom",
          ref: pageDom,
          onClick: _cache[1] || (_cache[1] = $event => nextPage())
        }, " 查看更多 ", 512)) : (_openBlock(), _createElementBlock("div", _hoisted_11, "—— 已到底 ——"))])) : (_openBlock(), _createBlock(_component_a_pagination, {
          key: 1,
          class: "pagination main",
          size: "small",
          current: pageOption.current,
          "onUpdate:current": _cache[2] || (_cache[2] = $event => pageOption.current = $event),
          "page-size": pageOption.size,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = $event => pageOption.size = $event),
          total: pageOption.total,
          "show-total": total => `共${total}条`,
          pageSizeOptions: [10, 20, 30],
          onChange: _cache[4] || (_cache[4] = $event => getDataList())
        }, null, 8, ["current", "page-size", "total", "show-total"]))]),
        _: 1
      }, 8, ["locale"])], 64);
    };
  }
};